<template>
  <div ref="qrcode" v-show="qrShow"></div>
</template>

<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";

export default {
  props: [],
  data() {
    return {
      qrShow: false
    };
  },
  onLoad() {},
  methods: {
    // 创造二维码
    qrCreate(url) {
      this.qrShow = true;
      new QRCode(this.$refs.qrcode, {
        width: 120, // 二维码宽度，单位像素
        height: 120, // 二维码高度，单位像素
        text: url // 生成二维码的链接
      });
    },

    // 保存二维码到相册
    qrSave() {
      html2canvas(this.$refs.qrcode).then((canvas) => {
        let link = document.createElement("a");
        link.href = canvas.toDataURL();
        link.setAttribute("download", "分享二维码.png");
        link.style.display = "none";
        document.body.appendChild(link);
        link.click();
      });
    }
  }
};
</script>

<style scoped></style>
